import {
  Remove,
  Add,
  ErrorOutlineOutlined,
  CheckCircle,
} from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { AICompatibilityRow } from 'components/AITools/components/AICompatibilityRow';
import { useAICompatibilityTableStyles } from 'components/AITools/constants/styles';

export const AICompatibilityTable = ({
  selectedSlides,
  model,
  incompatibleSlidesCount,
  issuesCount,
  availableToProcessSlides,
  setAvailableToProcessSlides,
}) => {
  const { classes } = useAICompatibilityTableStyles();

  return (
    <Accordion className={classes.confirmTable} disableGutters defaultExpanded>
      <AccordionSummary className={classes.accordionSummary}>
        <Typography className={classes.title}>COMPATIBILITY</Typography>
        {issuesCount || incompatibleSlidesCount ? (
          <Typography
            className={`${classes.compatibilityText} ${classes.errorColor}`}
          >
            <ErrorOutlineOutlined fontSize="small" />
            <span>
              {issuesCount} issue(s) Found, {incompatibleSlidesCount} Slide(s)
              Incompatible
            </span>
          </Typography>
        ) : (
          <Typography
            className={`${classes.compatibilityText} ${classes.successColor}`}
          >
            <CheckCircle fontSize="small" />
            <span>Ready To Process</span>
          </Typography>
        )}
        <Box className={classes.expandIcon}>
          <Add className="expand" />
          <Remove className="collapse" />
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.confirmSlides}>
        <Box className={classes.confirmSlide}>
          <Box />
          <Box />
          <Typography className={classes.confirmHeader}>Slide Name</Typography>
          <Typography className={classes.confirmHeader} textAlign="center">
            Organ
          </Typography>
          <Typography className={classes.confirmHeader} textAlign="center">
            Species
          </Typography>
          <Typography className={classes.confirmHeader} textAlign="center">
            Stain Type
          </Typography>
        </Box>
        {selectedSlides?.map((slide) => (
          <AICompatibilityRow
            key={slide.uuid}
            slide={slide}
            model={model}
            isChecked={availableToProcessSlides?.includes(slide.uuid)}
            setAvailableToProcessSlides={setAvailableToProcessSlides}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
